function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: 275.55,
  cy: 285.426,
  r: 275.157,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#09009b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#08008e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.498,
  stopColor: "#05006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.929,
  stopColor: "#010038"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00002e"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M274.37 296.2s-1.93 22.23-17.39 21.26-9.66-19.33-5.8-26.09c3.87-6.76 13.53-16.43 36.72-10.63s27.06 31.89 21.26 49.28c-5.8 17.39-25.13 46.39-74.41 38.65-49.28-7.73-50.25-57.02-34.79-86.01 15.46-28.99 29.96-59.91 91.8-57.98 61.85 1.93 86.01 28.02 94.7 57.02 8.7 28.99 14.44 84.46-48.37 135.68s-154.56 12.17-181.62-11.99c-27.06-24.16-52.18-57.98-45.42-115.96 6.76-57.98 57.02-110.16 103.4-128.53s86.01-28.99 140.12-17.39 100.5 56.05 117.9 104.37 14.5 148.82-47.35 205.83S270.21 518.14 219 509.45c-51.22-8.7-123.74-72.18-142.73-126.27-18.15-51.72-21.02-127.03 21.26-201.98 12.33-21.86 41.26-74.6 102.43-104.37 44.29-21.55 106.56-28.45 186.51-15.46l16.43-37.69s-93.74-47.35-210.67 9.66S47.84 155.4 28.92 213.09C9.85 271.23-17.12 377.86 39.55 457.58c57.02 80.21 128.28 108.97 222.99 108.01s156.79-26.83 205.11-72.25 83.11-119.83 77.31-198.1c-4.79-64.68-64.35-154.27-111.7-176.49s-105.73-43.84-210.1-11.95S96.56 244.02 92.7 263.34c-3.87 19.33-16.43 117.15 54.12 169.34s138.1 58.66 209.7 20.07c73.09-39.39 85.04-138.19 77.31-181.68-7.73-43.49-30.92-96.64-122.73-97.6-91.8-.97-130.39 41.26-151.72 80.21-12.5 22.82-28.02 90.84 10.63 125.63s108.23 35.76 145.92 4.83 31.89-89.87 25.13-101.47-29.96-36.72-64.75-31.89-51.59 37.46-50.25 52.18c1.93 21.26 18.36 32.86 34.79 32.86s25.13-18.36 29.96-33.82l-16.44-5.8z",
  fill: "url(#a)"
});

function SvgSpiral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 551.1 573.21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiral);
export default __webpack_public_path__ + "static/media/spiral.5a086c6c.svg";
export { ForwardRef as ReactComponent };